import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { environment } from '../environments/environment';
import { AuthService } from './services/auth/auth.service';
import { Observable, Subscription, interval } from 'rxjs';
import { DashboardProfileService } from './services/dashboardProfile/dashboard-profile.service';
import { Config } from './containers/glimpse-layout/components/nav-list/nav.config';
import { getUserData, setUserData } from './util/manageUserData';
declare let gtag: Function;
@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  private updateSubscription: Subscription;
  title = 'CoreUI 2 for Angular 8';
  constructor(
    private router: Router,
    private serviceAuth: AuthService,
    private activatedRoute: ActivatedRoute,
    private dashboardProfileService: DashboardProfileService,
  ) {
    {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          gtag('config', 'G-GJ9JEBDXJ9', {
            page_path: event.urlAfterRedirects,
          });
        }
      });
    }
  }
  config: Config = new Config();
  navItems;

  isUserLoggedIn = false;

  ngOnInit() {
    this.initBranding();
    this.isUserLoggedIn = this.serviceAuth.isUserLogedIn();

    if (this.isUserLoggedIn) {
      let project_key = environment.client_env;
      let homeRoute = environment[project_key]['home_route'];

      if (homeRoute) {
        let _ssRoute = sessionStorage.getItem('home_route');
        if (!_ssRoute) {
          sessionStorage.setItem('home_route', homeRoute);
          this.router.navigateByUrl(homeRoute);
        }
      }
    } else {
      if (!this.router.navigated) {
        if (environment.client_env !== 'pandg') {
          this.router.navigateByUrl('/login');
        } else if (!this.router.url.includes('oauthredirect')) {
          // this.router.navigateByUrl('/login')
        }
      }
      this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationEnd) {
          const isLoggedIn = this.serviceAuth.isUserLogedIn();
          if (
            environment.client_env !== 'pandg' &&
            !isLoggedIn &&
            !evt.url.includes('reset-password-session') &&
            !evt.url.includes('verify-otp') &&
            !evt.url.includes('reset-old-password')
          ) {
            this.router.navigateByUrl('/login');
          } else {
            if (
              !evt.url.includes('oauthredirect') &&
              !isLoggedIn &&
              !evt.url.includes('reset-password-session') &&
              !evt.url.includes('verify-otp') &&
              !evt.url.includes('reset-old-password')
            ) {
              this.router.navigateByUrl('/login');
            }
          }
        }
      });
    }
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
    this.getOwnerProfileData();
    this.updateSubscription = interval(300000).subscribe((val) => {
      this.getOwnerProfileData();
    });
  }

  initBranding() {
    let title = document.getElementsByTagName('title');
    let client = environment.client_env;
    title[0].innerText = environment[client]['title'];

    let link = document.getElementById('ficon');
    //@ts-ignore
    link.href = environment[client]['favicon'];
  }
  userData;
  token: string;
  email_address: string;
  getOwnerProfileData() {
    const userDataStorage = getUserData();
    this.token = userDataStorage['token'];
    this.userData = userDataStorage;
    this.email_address =
      userDataStorage['store_detail_dictionary']['user_details'][
        'email_address'
      ];
    this.dashboardProfileService
      .getOwnerProfileDataService(this.token, this.email_address)
      .then((res) => {
        if (res['success'] === '1') {
          this.userData['side_section_access'] =
            res['data']['side_section_access'];
          this.userData['store_detail_dictionary']['user_details'] =
            res['data']['store_detail_dictionary']['user_details'];
          this.userData['logo_image_url'] = res['data']['logo_image_url'];
          localStorage.setItem(
            'footfall_filter_state',
            res['data']['footfall_filter_state'],
          );
          setUserData(this.userData);
        } else if (res['success'] == '0' && res['message'] == 'Login Failed') {
          this.router.navigate(['/login']);
        }
      });
  }
}
